import React from 'react';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/FormSubmitButton';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import { TextInputField } from '../../../components/FormCom/FormField';

interface ITrackPackageForm {
  trackPackageInitialValues: any;
  TrackPackageSchema: any;
  onSubmit: any;
  trackPackageLoading: any;
}
const TrackPackageForm: React.FC<ITrackPackageForm> = ({
  trackPackageInitialValues,
  TrackPackageSchema,
  onSubmit,
  trackPackageLoading,
}) => {
  return (
    <TrackFormBox>
      <FormComponent
        initialValues={trackPackageInitialValues}
        schema={TrackPackageSchema}
        onSubmit={onSubmit}
        className='inline inline-responsive'
      >
        <TextInputField
          label='Track your parcel'
          name='trackingId'
          id='trackingId'
          type='text'
          placeholder='Enter Parcel ID'
        />
        <FormSubmitButton className='full-parent' loading={trackPackageLoading}>
          Track
        </FormSubmitButton>
      </FormComponent>
    </TrackFormBox>
  );
};

export default TrackPackageForm;

const TrackFormBox = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 24px;
  padding-bottom: 12px;
  border-radius: 10px;
`;
